import { createEntityAdapter } from '@reduxjs/toolkit';
import { schema } from 'normalizr';
import { gadgetSchema } from 'redux/gadget-update/gadget-update.adapter';
import { RootState } from 'redux/store';
import { LayoutEditResponse } from 'types/entity';

export const layoutSchema = new schema.Entity(
  'layouts',
  { gadget: [gadgetSchema] },
  {
    idAttribute: (value: LayoutEditResponse) => value.layout_id || '',
  },
);

export const layoutsAdapter = createEntityAdapter<LayoutEditResponse>({
  selectId: (model) => model.layout_id || '',
});

export const {
  selectById: selectLayoutById,
  selectIds: selectLayoutIds,
  selectEntities: selectLayoutEntities,
  selectAll: selectAllLayouts,
  selectTotal: selectTotalLayouts,
} = layoutsAdapter.getSelectors<RootState>((state) => state.layoutUpdate);
